import { cn } from '@/utils/styles';
import Header from './Header';
import Container from './Container';
import Footer from './Footer';

interface LayoutProps {
  children?: React.ReactNode;
  className?: string;
  gradientBg?: boolean;
  containerClassName?: string;
}

interface FullScreenLayoutProps extends LayoutProps {
  headerAddon?: React.ReactNode;
}

function Layout({
  children,
  className,
  gradientBg,
  containerClassName,
}: LayoutProps) {
  const gradientStyle = {
    backgroundImage:
      'radial-gradient(100% 100% at 50% 0%, #161B23 0%, #0A0E14 100%)',
  };

  return (
    <div
      style={gradientBg ? gradientStyle : undefined}
      className={cn(
        'relative flex size-full flex-col items-center',
        className,
      )}>
      <Header />
      <div className="flex size-full min-h-full pt-[var(--header-height)]">
        <Container className={containerClassName}>{children}</Container>
      </div>
      <Footer />
    </div>
  );
}

function FullScreenLayout({
  children,
  headerAddon,
  containerClassName,
}: FullScreenLayoutProps) {
  return (
    <div className="relative flex h-dvh w-screen flex-col items-center bg-neutral-1000">
      <Header addon={headerAddon} />
      <div className="flex size-full flex-1 grow">
        <Container className={containerClassName}>{children}</Container>
      </div>
    </div>
  );
}

export default Layout;
export { FullScreenLayout };
